import { ConfigurationMarkdownViewer } from '../markdownviewer/ConfigurationMarkdownViewer'

type Props = {
  children: string
}

export const ChangelogMarkdownViewer = ({ children }: Props) => (
  <ConfigurationMarkdownViewer
    className="[&_img]:w-lg [&_video]:w-lg [&_video]:min-w-lg text-justify max-w-4xl"
    isTrusted
  >
    {children}
  </ConfigurationMarkdownViewer>
)
